/**
 * 🧠 AI プロンプト Hub
 * v3.3 IA 刷新: prompts.templates + prompts.presets を統合した親ページ。
 */
import { HubTabs, type TabSpec } from '@/components/layout/HubTabs';

import { PromptTemplatesPage } from './templates/PromptTemplatesPage';
import { PromptPresetsPage } from './presets/PromptPresetsPage';

const TABS: TabSpec[] = [
  {
    tabKey: 'templates',
    label: 'テンプレート',
    featureId: 'prompts.templates',
    render: () => <PromptTemplatesPage />,
  },
  {
    tabKey: 'presets',
    label: 'プレセット',
    featureId: 'prompts.presets',
    render: () => <PromptPresetsPage />,
  },
];

export function PromptsHubPage() {
  return <HubTabs tabs={TABS} defaultTab="templates" />;
}
